
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { NextSeo } from 'next-seo';
import { GetServerSideProps } from 'next';
import { handleError } from '@/helpers/handleError';
import { GET_CATEGORY, GET_HEADER_DATA, GET_FOOTER_DATA, GET_ALL_EBOOKS, GET_COOKIES, GET_CATEGORY_PAGINATION, } from '@/graphql/queries';
import { BreadcrumbType } from '@/Types/types';
import HeaderMenu from '@/components/HeaderMenu';
import Footer from '@/components/Footer';
import BannerCategoryTag from '@/components/BannerCategoryTag';
import HighlightPostsCategory from '@/components/HighlightPostsCategory';
import RecentlyPublished from '@/components/BlogPage/RecentlyPublished';
import TagsBlock from '@/components/TagsBlock';
import ContactBlock from '@/components/ContactBlock';
import SubscribeBlogBlock from '@/components/SubscribeBlogBlock';
import EbookCard from '@/components/EbookCard';
import SubscribeBlock from '@/components/SubscribeBlock';
import { breadcrumbInitial } from '@/data/breadcrumbInitial';
import { ONE_MINUTE_IN_SECONDS, TEN_SECONDS } from '@/constants/timeConstants';
import { addApolloState, initializeApollo } from '@/lib/apolloClient';
export default function CategoryPage({ cookies, header, navbar, homepage, breadcrumbs, footer, tags, categoryPosts, category, ebooks, }: any) {
    return (<>
      <HeaderMenu cookies={cookies.data} menu={header[0].items} submenu={navbar.data?.attributes.menu_header_list}/>
      <NextSeo title={category.data[0].attributes.metaTitle} description={category.data[0].attributes.metaDescription} canonical={category.data[0].attributes.canonicalURL}/>
      <BannerCategoryTag title={category.data[0]?.attributes.title} description={category.data[0]?.attributes.description} breadcrumbs={breadcrumbs} counter={categoryPosts.meta.pagination.total}/>
      <Box maxWidth="1216px" margin="0 auto" width="90%" mb="32px" as="header" pt={{ base: '40px', lg: '80px' }}>
        <HighlightPostsCategory data={categoryPosts.data}/>
      </Box>
      <Flex maxWidth="1216px" m="0 auto" w="100%" gap="56px" justifyContent="space-between" direction={{ base: 'column', lg: 'row' }}>
        <RecentlyPublished posts={categoryPosts.data} noFilter/>

        <Flex m="0 auto" mt={{ base: '0', lg: '150px' }} w={{ base: '90%', lg: '500px' }} direction="column" gap="64px">
          {tags.data.length > 0 && <TagsBlock tags={tags.data}/>}
          <ContactBlock />
          <SubscribeBlogBlock />
          {ebooks.data.length > 0 && (<Flex direction="column">
              <Text lineHeight="28px" fontWeight="700" fontSize="18px" textAlign="left" mb="12px">
                E-books populares
              </Text>
              <Flex direction="column" gap="32px">
                {ebooks.data.slice(0, 3).map((ebook: any) => (<EbookCard data={ebook} key={ebook.id}/>))}
              </Flex>
            </Flex>)}
        </Flex>
      </Flex>
      <SubscribeBlock />
      <Footer menu={footer[0].items} clients={homepage.data.attributes.clients.data}/>
    </>);
}
const getServerSideProps: GetServerSideProps = async (context) => {
    try {
        context.res.setHeader('Cache-Control', `public, s-maxage=${TEN_SECONDS}, stale-while-revalidate=${ONE_MINUTE_IN_SECONDS}`);
        const client = initializeApollo();
        const { data: categoryData } = await client.query({
            query: GET_CATEGORY,
            variables: {
                slugUrl: context.params?.slug
            }
        });
        if (!categoryData.category.data.length) {
            return {
                notFound: true
            };
        }
        const { data: categoryPosts } = await client.query({
            query: GET_CATEGORY_PAGINATION,
            variables: {
                slugUrl: context.params?.slug,
                /* eslint-disable */
                page: (context.query?.page && +context.query?.page) || 1
            }
        });
        const { data: headerData } = await client.query({
            query: GET_HEADER_DATA
        });
        const { data: footerData } = await client.query({
            query: GET_FOOTER_DATA
        });
        const { data: cookiesData } = await client.query({
            query: GET_COOKIES
        });
        const breadcrumbs: BreadcrumbType[] = JSON.parse(JSON.stringify(breadcrumbInitial));
        breadcrumbs.push({
            href: '/blog/categoria',
            label: 'Categorias'
        });
        breadcrumbs.push({
            href: `/blog/categoria/${categoryData.category.data[0].attributes.slug}`,
            label: `${categoryData.category.data[0].attributes.metaTitle}`
        });
        const { data: ebooksData } = await client.query({
            query: GET_ALL_EBOOKS,
            variables: {
                /* eslint-disable */
                page: (context.query?.page && +context.query?.page) || 1
            }
        });
        return addApolloState(client, {
            props: {
                ...categoryPosts,
                ...cookiesData,
                ...categoryData,
                ...headerData,
                ...footerData,
                breadcrumbs,
                ...ebooksData
            }
        });
    }
    catch (error) {
        handleError(error, 'Categoria Slug getServerSideProps');
        return {
            notFound: true
        };
    }
};

    async function __Next_Translate__getServerSideProps__194852ea60e__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/categoria/[slug]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: typeof __i18nConfig.loadLocaleFrom === 'function' ? __i18nConfig.loadLocaleFrom : (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__194852ea60e__ as getServerSideProps }
  